import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpSentEvent } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: "root"
})
export class BaseService {
  userAuthenticationDetails: any = null;
  options: Options;
  roles: any = null;
  userdetails: any = null;
  
  constructor(private http: HttpClient) {
    this.options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
       // 'x-auth-token':  this.getUserAuthenticationDetails()
        'Authorization': 'Bearer ' + this.getUserAuthenticationDetails()
      })
    };
  }

  getToken(){
    return this.options = {
       headers: new HttpHeaders({
         'Content-Type': 'application/json',
        // 'x-auth-token': JSON.parse(localStorage.getItem("auth_details"))
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("currentToken")as string),         
       })
   };
 }
 
 public callPostServiceForLogin(url, param): Observable<HttpEvent<any>> {
  let httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
   
  });
  return this.http.post<any>(url, JSON.stringify(param),{ headers: httpHeaders });
}
 public callPostService(url, param): Observable<HttpEvent<any>> {

  return this.http.post<any>(url, param);
}
// public callPostServiceForLoginBrokerByPass(url, param, token): Observable<HttpEvent<any>> {
//   //debugger
//   let httpHeaders = new HttpHeaders({
//     'token': ` ${token}`
//   });

//   return this.http.post<any>(url, JSON.stringify(param), { headers: httpHeaders });
// }
callPostServiceForLoginBrokerByPass(url: string, body: FormData): Observable<any> {
  return this.http.post(url, body);
}
   public callGetServiceCall(url): Observable<HttpEvent<any>> {
   
    return this.http.get<any>(url);

  }
  public callPutService(url,param): Observable<HttpEvent<any>>{
    return this.http.put<any>(url, JSON.stringify(param),this.getToken());
  } 

  public callDeleteService(url):Observable<HttpEvent<any>>{
    return this.http.delete<any>(url,this.getToken());
  } 
 
  public submitFormService(url, FormData): Observable<HttpEvent<any>> {
    let httpHeaders = new HttpHeaders({
     // 'Content-Type': 'application/json',
     // 'Cache-Control': 'no-cache',
      'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("currentToken")as string),
    });
    return this.http.post<any>(url, FormData, { headers: httpHeaders });
  }
   public setUserAuthenticationDetails(data){
    this.userAuthenticationDetails=data; 
    localStorage.setItem("currentToken",JSON.stringify(data));
}
   public getUserAuthenticationDetails(){
    if(this.userAuthenticationDetails==null)
    try{this.userAuthenticationDetails=JSON.parse(localStorage.getItem("currentToken")as string); 
    return this.userAuthenticationDetails;
    }catch(err){localStorage.clear();
    }
    
    }
    public setUserDetails(data) {
      this.userdetails = data;
      localStorage.setItem("userdetails", JSON.stringify(data));
    }
    public handleError(error): boolean {
      return true;
    }
    
}
// export class ResponseFormat {
//   error: string;
//   message: string;
//   data: any;
//   status: string;
// }

class Options {
  headers?: HttpHeaders | { [header: string]: string | string[]; };
  observe?: "body";
  params?: HttpParams | { [param: string]: string | string[]; };
  reportProgress?: boolean;
  responseType?: "json";
  withCredentials?: boolean;
}